import SbUtils from '../../Utils/SbUtils'

const Button = ( props ) => {

    const   slug = 'sb-btn',
            classesList =  [ 'type', 'size' ],
            actionsList =  [ 'onClick' ],
            attributesList = [
                { 'icon-position' : 'left'},
                'full-width',
                'boxshadow',
                'disabled',
                'loading'
            ],
            stylesList = [
                'fontSize',
                'backgroundColor',
            ];

    const isIconOnly = ! props?.text && Boolean( props?.icon );

    if ( process.env.NODE_ENV !== 'production' && isIconOnly && ! props?.ariaLabel ) {
        // eslint-disable-next-line no-console
        console.warn( '[sb-customizer] Icon-only Button is missing aria-label.' );
    }

    return (
        <button
            type="button"
            className={ SbUtils.getClassNames( props, slug, classesList ) }
           { ...SbUtils.getElementActions( props, actionsList ) }
           { ...SbUtils.getElementAttributes( props, attributesList ) }
           data-onlyicon={ isIconOnly ? 'true' : undefined }
           aria-label={ isIconOnly ? props?.ariaLabel : undefined }
           style={ SbUtils.getElementStyles( props, stylesList ) }
        >
            { SbUtils.printIcon( props.icon, 'sb-btn-icon', false, props?.iconSize ) } { props.text }
            {
                props?.tooltip !== undefined &&
                SbUtils.printTooltip( props.tooltip, {
                    type : props?.tooltipType,
                    position : props?.tooltipPosition
                } )
            }
        </button>
    )
}

export default Button;